export const ProjectData = [
  {
    id: 2,
    title: "ShatRanj AI",
    about:
      "A chess engine written in JavaScript. AI uses Min Max Algorithm in Game Decision Tree with Alpha Beta pruning for time optimization. Used Piece Square Tables for the board evaluation at each step.",
    tags: ["HTML", "CSS", "JavaScript"],
    demo: "https://dbarnwal.github.io/ShatRanj-AI-Chess/",
    github: "https://github.com/dbarnwal/Shatranj-AI-Chess-1",
    image: require("../../assets/Shatranj.png"),
  },
  {
    id: 1,
    title: "Text Editor++",
    about:
      "A Text Editor which auto compress text files on saving, using Huffman Encoding , Bit Packing . Achieved an average compression of 50% and best case 80% of the original file.",
    tags: ["QT Framework", "C++", "File Handling"],
    demo: "link",
    github: "",
    image: require("../../assets/wip.png"),
  },
];
